import styled from 'styled-components';

export const ReportSettingsContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 48%;
  align-items: start;
  @media (max-width: 1110px) {
    display: block;
  }
`;
